var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 6,
    viewBox: "0 0 182 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(-441 -521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(441 521)",
    fill: "#c5cae1",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-2",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(457 521)",
    fill: "#c5cae1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-3",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(473 521)",
    fill: "#c5cae1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-4",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(489 521)",
    fill: "#c5cae1",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-5",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(505 521)",
    fill: "#c5cae1",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-6",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(521 521)",
    fill: "#c5cae1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-7",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(537 521)",
    fill: "#c5cae1",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-8",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(553 521)",
    fill: "#c5cae1",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-9",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(569 521)",
    fill: "#c5cae1",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-10",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(585 521)",
    fill: "#c5cae1",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-11",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(601 521)",
    fill: "#c5cae1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-12",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(617 521)",
    fill: "#c5cae1",
    opacity: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.032475107206da26364abbffb73f45df.svg";
export { ForwardRef as ReactComponent };